/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { AppConfig, CHANNELS } from "@nf/constants";
import { IThemeContext } from "../context/ThemeContext";
import { MediaChannelType } from "../enums";

export const setBrandingFromUrl = (
  screenKey: string,
  channelContext: IThemeContext
) => {
  if (channelContext.onBrandingChange && !screenKey) {
    channelContext.onBrandingChange(CHANNELS.NF_PLUS);
  }
  if (channelContext.onBrandingChange && screenKey) {
    switch (screenKey) {
      case AppConfig?.ChannelDansk:
        channelContext.onBrandingChange(CHANNELS.DANSK_FILMSKAT);
        break;
      case AppConfig?.ChannelKids:
        channelContext.onBrandingChange(CHANNELS.KIDS);
        break;
      default:
        channelContext.onBrandingChange(CHANNELS.NF_PLUS);
        break;
    }
  }
};

export const channelRouteToChannelTypeMapping = {
  [AppConfig.ChannelHome]: MediaChannelType.NFplus,
  [AppConfig.ChannelDansk]: MediaChannelType.Dansk_Filmskat,
  [AppConfig.ChannelKids]: MediaChannelType.Kids,
};

export const getChannelTypeFromChannelRoute = (channel: string) => {
  return channelRouteToChannelTypeMapping[channel];
};

export const CHANNEL_LOGOS = {
  [AppConfig.ChannelHome]: {
    compact: "/assets/channels/home/compact.svg",
    full: "/assets/channels/home/full.svg",
    labeled: "/assets/channels/home/labeled.svg",
  },
  [AppConfig.ChannelDansk]: {
    compact: "/assets/channels/dansk/compact.svg",
    full: "/assets/channels/dansk/full.svg",
    labeled: "/assets/channels/dansk/labeled.svg",
  },
  [AppConfig.ChannelKids]: {
    compact: "/assets/channels/kids/compact.svg",
    full: "/assets/channels/kids/full.svg",
    labeled: "/assets/channels/kids/labeled.svg",
  },
};
